export default __webpack_public_path__ + "static/media/Gallery.83a94a2f.jpg";